import React from "react";
import { Link } from "react-router-dom";

import './PageTitle.css'

const PageTitle = ({ title, link, currentPage, category, linkCategory, detail }) => {
  return (
    <section className="wpo-page-title">
      <div className="container">
        <div className="row">
          <div className="col col-xs-12">
            <div className="wpo-breadcumb-wrap">
              <h2>{title}</h2>
              <ol className="wpo-breadcumb-wrap">
                <li>
                  <Link to="/">Acceuil</Link>
                </li>
                <li>
                  <span>❯</span>
                </li>
                <li>
                  {
                    link ?
                      <Link to={"/" + link}>{currentPage}</Link>
                      :
                      <span>{currentPage}</span>
                  }
                </li>
                <li>
                  <span>{category ? "❯" : ""}</span>
                </li>
                <li>
                  {
                    linkCategory ?
                      <Link to={"/" + link + "/" + linkCategory}>{category}</Link>
                      :
                      <span>{category}</span>
                  }
                </li>
                <li>
                  <span>{detail ? "❯" : ""}</span>
                </li>
                <li>
                  <span>{detail}</span>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageTitle;
